const supportMenu = {
  supportAriaLabel: "Support",
  chatWithUsTitle: "Chat with us",
  chatWithUsDescription: "Get help faster through our virtual assistance chat.",
  supportCenter: "Support center",
  supportCenterDescription: "Find how-tos, videos, policies and other resources.",
  bookADemo: "Book a demo",
  bookADemoDescription: "Schedule a 1:1 session with one of our specialists.",
};

export { supportMenu };
